module.exports = __webpack_public_path__ + "static/media/last_login.215a3326.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/last_login.svg
// module id = 855
// module chunks = 0